export default __webpack_public_path__ + "static/portfolio-9-fd653dc040a986706c7ab6e3777697c2.jpg";